<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" v-bind="attrs" v-on="on" dark height="39px">
          Novo
        </v-btn>
      </template>
      <v-card class="card-show">
        <v-toolbar dark flat color="#042333" height="56px">
          <v-btn icon dark @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="subtitle-1">
            Orçamento Fornecedor
          </v-toolbar-title>
        </v-toolbar>
        <v-data-table
          v-model="selected"
          :items="orcamento.itens"
          :headers="headers"
          hide-default-footer
          disable-pagination
          fixed-header
          :item-key="orcamento.itens ? orcamento.itens.mes : ''"
          v-if="orcamento"
          class="table-orcamento-resposivo"
          height="calc(100vh - 165px)!important"
          show-select
        >
          <template v-slot:top>
            <v-toolbar flat color="white" height="56px">
              <v-toolbar-title>
                Ano: {{ orcamento.ano }} | Comprador:
                {{ orcamento.comprador ? orcamento.comprador.text : "" }} |
                Fornecedor:
                {{ orcamento.fornecedor ? orcamento.fornecedor.text : "" }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                dark
                color="primary"
                @click="dialogNew = true"
                class="ml-2"
                v-if="selected.length > 0"
              >
                Editar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.total_previsto_compra="{ item }">
            <v-text-field
              v-model="item.total_previsto_compra"
              v-currency="currency"
              single-line
              hide-details
              @focus="$event.target.select()"
              @blur="totalPrevistoCompra(item)"
              class="total_previsto_compra"
            ></v-text-field>
          </template>
          <template v-slot:item.mes="{ item }">
            {{ mMes(item.mes) }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn icon title="Remover Mês" @click="excluir(item)" small>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" @click="fechar" v-if="editado"> Cancelar </v-btn>
          <v-btn color="#042333" dark @click="salvar" v-if="editado">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNew"
      max-width="500px"
      content-class="orcamento-show"
      :retain-focus="false"
    >
      <v-card style="border: 1px solid #fff">
        <v-toolbar dark flat color="#042333" height="50px">
          <v-btn icon dark @click.stop="fecharNew">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pb-0 pt-2"
          align-center
          style="min-height: calc(100vh - 215px); overflow-y: auto"
        >
          <v-select
            v-model="form.ano"
            :items="selects.ano"
            class="mt-4"
            label="Ano*"
            outlined
            :error-messages="errorAno"
            @input="$v.form.ano.$touch()"
            @blur="$v.form.ano.$touch()"
          ></v-select>
          <v-select
            v-model="form.mes"
            :items="selects.mes"
            label="Mes*"
            chips
            attach
            multiple
            outlined
            :error-messages="errorMes"
            @input="$v.form.mes.$touch()"
            @blur="$v.form.mes.$touch()"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="form.mes.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Todos </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
          <v-autocomplete
            v-model="form.fornecedor_id"
            :items="selects.fornecedores"
            label="Fornecedor*"
            clearable
            outlined
            color="#042333"
            :error-messages="errorFornecedor"
            @input="$v.form.fornecedor_id.$touch()"
            @blur="$v.form.fornecedor_id.$touch()"
          >
          </v-autocomplete>
          <v-autocomplete
            v-model="form.comprador_id"
            :items="selects.compradores"
            label="Comprador*"
            clearable
            outlined
            color="#042333"
            :error-messages="errorComprador"
            @input="$v.form.comprador_id.$touch()"
            @blur="$v.form.comprador_id.$touch()"
          >
          </v-autocomplete>
          <v-text-field
            v-model="form.total_previsto_compra"
            outlined
            label="Total Previsto da Compra Mensal(R$)*"
            v-currency="currency"
            :error-messages="errorTotalPrevistoCompra"
            @input="$v.form.total_previsto_compra.$touch()"
            @blur="$v.form.total_previsto_compra.$touch()"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" @click.stop="fecharNew"> Cancelar </v-btn>
          <v-btn color="#042333" dark @click="orcar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      dialogNew: false,
      editado: false,
      title: "Novo Orçamento",
      selected: [],
      headers: [
        { text: "", value: "" },
        { text: "Mês", value: "mes", align: "left", width: "100px" },
        {
          text: "Total Previsto de Compra",
          value: "total_previsto_compra",
          width: "190px",
          align: "center",
        },
        { text: "", value: "" },
        { text: "", value: "action", width: "50px" },
      ],
      form: {
        fornecedor_id: "",
        comprador_id: "",
        ano: "",
        mes: "",
        total_previsto_compra: "",
      },
      currency: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 2,
        allowNegative: false,
        valueAsInteger: false,
        autoDecimalMode: false,
      },
    };
  },
  validations: {
    form: {
      fornecedor_id: { required },
      comprador_id: { required },
      ano: { required },
      mes: { required },
      total_previsto_compra: { required },
    },
  },
  computed: {
    ...mapGetters("orcFornecedor", ["orcamento", "selects"]),
    errorFornecedor() {
      const errors = [];
      if (!this.$v.form.fornecedor_id.$dirty) return errors;
      !this.$v.form.fornecedor_id.required &&
        errors.push("O fornecedor é obrigatório.");
      return errors;
    },
    errorComprador() {
      const errors = [];
      if (!this.$v.form.comprador_id.$dirty) return errors;
      !this.$v.form.comprador_id.required &&
        errors.push("O comprador é obrigatório.");
      return errors;
    },
    errorMes() {
      const errors = [];
      if (!this.$v.form.mes.$dirty) return errors;
      !this.$v.form.mes.required && errors.push("O mês é obrigatório.");
      return errors;
    },
    errorAno() {
      const errors = [];
      if (!this.$v.form.ano.$dirty) return errors;
      !this.$v.form.ano.required && errors.push("O ano é obrigatório.");
      return errors;
    },
    errorTotalPrevistoCompra() {
      const errors = [];
      if (!this.$v.form.total_previsto_compra.$dirty) return errors;
      !this.$v.form.total_previsto_compra.required &&
        errors.push("O valor é obrigatório.");
      return errors;
    },
    allMonth() {
      return this.form.mes.length === this.selects.mes.length;
    },
    someMonth() {
      return this.form.mes.length > 0 && !this.allMonth;
    },
    icon() {
      if (this.allMonth) return "mdi-close-box";
      if (this.someMonth) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    salvar() {
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.dispatch("orcFornecedor/Store").then(() => {
          this.fechar();
        })
      );
    },
    fechar() {
      this.title = "Novo Orçamento";
      this.form = {
        fornecedor_id: "",
        comprador_id: "",
        ano: "",
        mes: "",
        total_previsto_compra: "",
      };
      this.dialog = false;
      this.$v.$reset();
    },
    fecharNew() {
      if (!this.editado) {
        this.dialog = false;
      }
      this.dialogNew = false;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allMonth) {
          this.form.mes = [];
        } else {
          this.form.mes = this.selects.mes.slice();
        }
      });
    },
    orcar() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.editado = true;
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.dispatch("orcFornecedor/Orcar", this.form).then(() => {
          this.dialogNew = false;
        })
      );
    },
    totalPrevistoCompra(item) {
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.commit("orcFornecedor/setTotalPrevistoCompra", item)
      );
      this.editado = true;
    },
    mMes(mes) {
      return this.selects.mes.find((sm) => sm.value == mes).text;
    },
    excluir(item) {
      if (confirm("Deseja remover o Mês?")) {
        this.$store.commit("orcFornecedor/excluir", item);
        this.editado = true;
      }
    },
  },
  created() {
    let start = moment().format("YYYY");
    start = moment().subtract("2", "years").format("YYYY");
    let end = moment().add("2", "years").format("YYYY");
    this.selects.ano = this.selects.ano.filter(
      (s) => s.value >= start && s.value <= end
    );
  },
  watch: {
    dialog() {
      if (this.dialog) {
        if (!this.item) {
          this.$store.dispatch(
            "loading/addRequisicao",
            this.$store.dispatch("orcFornecedor/Orcamentos", {})
          );

          if (!this.dialogNew) {
            setTimeout(() => {
              this.dialogNew = true;
            }, 30);
          }
        }
        this.selected = [];
      } else {
        this.editado = false;
        this.$emit("eItem");
      }
      this.$v.$reset();
    },
    item() {
      if (this.item) {
        this.form = {
          fornecedor_id: this.item.fornecedor_id,
          comprador_id: this.item.comprador_id,
          ano: this.item.ano.toString(),
          mes: "",
          total_previsto_compra: "",
        };
        this.$store.dispatch(
          "loading/addRequisicao",
          this.$store.dispatch("orcFornecedor/Orcamentos", {
            fornecedor_id: this.item.fornecedor_id,
            comprador_id: this.item.comprador_id,
            ano: this.item.ano,
          })
        );
        this.title = "Editar Orçamento";
        this.dialog = !this.dialog;
      }
    },
  },
};
</script>
<style>
.orcamento-show
  .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box
  .v-select__selections,
.orcamento-show
  .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed
  .v-select__selections {
  min-height: 40px;
}

.table-orcamento-resposivo .v-toolbar__content {
  border-bottom: 1px solid #e0e0e0;
}

.table-orcamento-resposivo.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 0.875rem;
  height: 41px;
}

.total_previsto_compra input {
  text-align: center !important;
  margin: 0;
  padding: 0;
  padding-left: 3px;
  margin-top: -17px;
  font-size: 15px;
}

.total_previsto_compra.error--text input {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}

.table-orcamento-resposivo table tr th:first-child,
.table-orcamento-resposivo table tr td:first-child {
  padding: 2px 0px 0px 24px !important;
}

.card-show .v-card__actions {
  height: 53px;
}
</style>
